import { FC } from 'react';
import styled, { keyframes } from 'styled-components';

import PromptBox from './PromptBox';

const shine = keyframes`
 to {
    background-position-x: -200%;
  }
`;

const Holder = styled.div`
  margin-bottom: 16px;
  page-break-inside: avoid;
`;

const Box = styled.div<{ $height?: number }>`
  background: #eee;
  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
  background-size: 200% 100%;
  opacity: 0.7;
  width: 100%;
  height: ${({ $height }) => $height}px;
  animation: 1.5s ${shine} linear infinite;
`;

interface Props {
  query?: string;
  aspectRatio?: string;
}

const ImageToolLoadingImage: FC<Props> = ({ query, aspectRatio }) => {
  const getRatio = () => {
    switch (aspectRatio) {
      case '1:1':
        return 1;
      case '2:3':
        return 2 / 3;
      case '3:2':
        return 3 / 2;
      case '5:4':
        return 5 / 4;
      case '4:7':
        return 4 / 7;
      case '7:4':
        return 7 / 4;
      default:
        return 1;
    }
  };

  return (
    <Holder>
      <Box $height={Math.round(347 / getRatio())} />
      {!!query && <PromptBox text={query} />}
    </Holder>
  );
};

export default ImageToolLoadingImage;
